"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var invariant_1 = require("./invariant");
var _1 = require("./_");
var simple_number_localizer_1 = require("../localizers/simple-number-localizer");
var simple_date_localizer_1 = require("../localizers/simple-date-localizer");
var simple_message_localizer_1 = require("../localizers/simple-message-localizer");
var REQUIRED_NUMBER_FORMATS = ['default'];
var REQUIRED_DATE_FORMATS = [
    'default',
    'date',
    'time',
    'header',
    'footer',
    'dayOfMonth',
    'month',
    'year',
    'decade',
    'century'
];
function _format(localizer, formatter, value, format, locale) {
    var result = typeof format === 'function'
        ? format(value, locale, localizer)
        : formatter.call(localizer, value, format, locale);
    invariant_1.default(result == null || typeof result === 'string', '`localizer format(..)` must return a string, null, or undefined');
    return result;
}
function checkFormats(requiredFormats, formats) {
    if (process.env.NODE_ENV !== 'production')
        requiredFormats.forEach(function (f) { return invariant_1.default(_1.has(formats, f), 'localizer missing required format: `%s`', f); });
}
var _numberLocalizer = emptyLocalizer(['formats', 'parse', 'format', 'precision', 'decimalChar']);
function setNumber(localizer) {
    var format = localizer.format, parse = localizer.parse, formats = localizer.formats, precision = localizer.precision, decimalChar = localizer.decimalChar;
    invariant_1.default(typeof format === 'function', 'number localizer `format(..)` must be a function');
    invariant_1.default(typeof parse === 'function', 'number localizer `parse(..)` must be a function');
    checkFormats(REQUIRED_NUMBER_FORMATS, formats);
    formats.editFormat = formats.editFormat || (function (str) { return parseFloat(str); });
    precision = precision || (function () { return null; });
    decimalChar = decimalChar || (function () { return '.'; });
    _numberLocalizer = {
        formats: formats,
        precision: precision,
        decimalChar: decimalChar,
        format: function (value, str, locale) {
            return _format(this, format, value, str, locale);
        },
        parse: function (value, locale, format) {
            var result = parse.call(this, value, locale, format);
            invariant_1.default(result == null || typeof result === 'number', 'number localizer `parse(..)` must return a number, null, or undefined');
            return result;
        }
    };
}
exports.setNumber = setNumber;
var _dateLocalizer = emptyLocalizer(['formats', 'parse', 'format', 'firstOfWeek', 'startOfWeek']);
function setDate(localizer) {
    var format = localizer.format, parse = localizer.parse, formats = localizer.formats, startOfWeek = localizer.startOfWeek;
    invariant_1.default(typeof format === 'function', 'date localizer `format(..)` must be a function');
    invariant_1.default(typeof parse === 'function', 'date localizer `parse(..)` must be a function');
    invariant_1.default(typeof startOfWeek === 'function', 'date localizer `startOfWeek(..)` must be a function');
    checkFormats(REQUIRED_DATE_FORMATS, formats);
    _dateLocalizer = {
        formats: formats,
        startOfWeek: startOfWeek,
        format: function (value, str, locale) {
            return _format(this, format, value, str, locale);
        },
        parse: function (value, format, locale) {
            var result = parse.call(this, value, format, locale);
            invariant_1.default(result == null
                || (result instanceof Date && !isNaN(result.getTime())), 'date localizer `parse(..)` must return a valid Date, null, or undefined');
            return result;
        }
    };
}
exports.setDate = setDate;
var _messageLocalizer = emptyLocalizer(['formatMessage']);
function setMessage(localizer) {
    var formatMessage = localizer.formatMessage;
    invariant_1.default(typeof formatMessage === 'function', 'message localizer `formatMessage(..)` must be a function');
    _messageLocalizer = {
        formatMessage: formatMessage
    };
}
exports.setMessage = setMessage;
setNumber(simple_number_localizer_1.simpleNumberLocalizer());
setDate(simple_date_localizer_1.simpleDateLocalizer());
setMessage(simple_message_localizer_1.simpleMessageLocalizer());
exports.number = {
    getFormat: function (key, format) {
        return format || _numberLocalizer.formats[key];
    },
    parse: function (num, locale, format) {
        return _numberLocalizer.parse(num, locale, format);
    },
    format: function (num, format, locale) {
        return _numberLocalizer.format(num, format, locale);
    },
    decimalChar: function (format, locale) {
        return _numberLocalizer.decimalChar(format, locale);
    },
    precision: function (format, locale) {
        return _numberLocalizer.precision(format, locale);
    }
};
exports.date = {
    getFormat: function (key, format) {
        return format || _dateLocalizer.formats[key];
    },
    parse: function (date, format, locale) {
        return _dateLocalizer.parse(date, format, locale);
    },
    format: function (date, format, locale) {
        return _dateLocalizer.format(date, format, locale);
    },
    startOfWeek: function (locale) {
        return _dateLocalizer.startOfWeek(locale);
    }
};
exports.message = {
    formatMessage: function (path, variables, locale) {
        return _messageLocalizer.formatMessage(path, variables, locale);
    }
};
exports.default = { number: exports.number, date: exports.date, message: exports.message };
function emptyLocalizer(props) {
    var empty = {};
    if (process.env.NODE_ENV !== 'production') {
        props
            .forEach(function (name) { return Object.defineProperty(empty, name, {
            enumerable: true,
            get: function () {
                throw new Error('[adp-react-components] You are attempting to use a widget that requires localization.' +
                    'However there is no localizer set. Please configure a localizer.' +
                    'Missing localizer method: ' + name);
            }
        }); });
    }
    return empty;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/localizers.js
// module id = 16
// module chunks = 0 1 2 3 4 5 6